



























































































import { Component, Prop, Inject, Vue, Watch } from "vue-property-decorator";
import { getMsTime } from "@/services/dateTime/pars-date-in-minutes";
import { IExcursion, IExcursionCategory } from "@/@types/excursions/excursions";
import { getBirthday as getDate } from "@/services/dateTime/getFullDate";

import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import html2canvas from "html2canvas";
import StandartModal from "@/components/app/standart-modal.vue";

interface ITimepicker {
  HH: string;
  mm: string;
}

@Component({ components: { StandartModal, DatePicker, VueTimepicker } })
export default class ExcursionTicket extends Vue {
  @Prop({ type: Object, default: null }) card!: IExcursion;
  @Prop({ type: Array, default: () => [] })
  categorys!: Array<IExcursionCategory>;

  @Inject({ from: "excursionFolder", default: null }) readonly folder!: string;
  @Inject({ from: "excursionBgFolder", default: null }) readonly bg!: string;
  date: Date | null = null;
  time: ITimepicker | null = null;

  $refs!: { ticket: HTMLElement };

  get category(): IExcursionCategory | null {
    const cat = this.categorys.find((el) => el._id == this.card.category);
    return cat ? cat : null;
  }

  get dateFormat(): Date | string {
    if (!this.date) return "";
    return getDate(this.date);
  }

  getMsTime(ms: number): {
    days: number;
    hours: number;
    minutes: number;
  } {
    return getMsTime(ms);
  }

  @Watch("time", { deep: true })
  updateDate(): void {
    if (!this.date || !this.time) return;
    const date = new Date(this.date);
    date.setMinutes(Number(this.time.mm));
    date.setHours(Number(this.time.HH));
    this.date = date;
  }

  @Watch("date")
  setTime(): void {
    if (!this.date) return;
    if (this.time) return;
    const arival = new Date(this.date);
    const minutes = arival.getMinutes();
    if (this.time)
      this.time = {
        HH: String(arival.getHours()),
        mm: String(minutes < 10 ? `0${minutes}` : minutes),
      };
  }

  async downloadElementAsJPG(
    element: HTMLElement,
    filename = "image.jpg"
  ): Promise<void> {
    try {
      // Рендерим элемент в canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Увеличиваем качество (можно настроить)
        logging: false, // Отключаем логи
        useCORS: true, // Разрешаем CORS для изображений
        allowTaint: true, // Разрешаем "загрязнение" canvas
      });

      // Конвертируем canvas в JPG и скачиваем
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/jpeg", 0.9); // 0.9 - качество JPG (0-1)
      link.download = filename;
      link.click();
    } catch (error) {
      console.error("Ошибка при создании изображения:", error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  onDownload(): void {
    const ticket = this.$refs.ticket;
    const name = this.$getLocale(this.card.name);
    this.downloadElementAsJPG(ticket, `${name}.jpg`);
  }
}
